
import _ from 'lodash';
import indexedDb from 'indexedDb';

export const limit = (value, { min, max }) => {
  const minCond = min ? [[(v) => v < min, () => min]] : [];
  const maxCond = min ? [[(v) => v > max, () => max]] : [];
  return _.cond([...minCond, ...maxCond, [_.stubTrue, () => value]])(value);
};

export const updateColumnsWidth = (columnsWidth, updateFn) => _.mapValues(columnsWidth, updateFn);

export async function setTableColsWidth(tableName, width) {
  return indexedDb.tableColsWidth.put({ tableName, width });
}

export async function getTableColsWidth(tableName) {
  return indexedDb.tableColsWidth.get(tableName);
}

export async function cleanTableColsWidth(tableName) {
  return indexedDb.tableColsWidth.delete(tableName);
}
